import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";

export default class Helpers {
  private configuration: SDKConfigurationModel;

  constructor(configuration: SDKConfigurationModel) {
    this.configuration = configuration;
  }

  public getSDKConfiguration(): SDKConfigurationModel {
    return this.configuration;
  }
}
